import script from "./ValidationResultExample.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./ValidationResultExample.component.vue?vue&type=script&lang=ts&setup=true"

import "./ValidationResultExample.component.vue?vue&type=style&index=0&id=4e6d64bb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6d64bb"]])

export default __exports__